import updateSiteSettings from '../../../actions/siteadmin/updateSiteSettings'
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {

    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;

    if (!values.ogImage) {
        return showToaster({ messageId: 'ogImageError', toasterType: 'error' })
    }
    await dispatch(updateSiteSettings(values));
}

export default submit;